import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLayoutModule, CommonUIModule } from '@sdbn/common';


import { AttributeGroupComponent } from './components/attribute-group/attribute-group.component';
import { CommonTranslationModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberInputModule } from '@sdbn/common';
import { ArticleSelectionComponent } from './components/article-selection/article-selection.component';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    AttributeGroupComponent,
    ArticleSelectionComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    FormsModule,
    ReactiveFormsModule,

    CommonUIModule,
    CommonTranslationModule,
    NumberInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule
  ],
  exports: [
    AttributeGroupComponent,
    ArticleSelectionComponent
  ]
})
export class ErpCommonModule { }
